<template>
  <div class="position-relative">
    <b-form-input
      v-model="filter"
      class="mb-3 mb-lg-0"
      :class="fontSizeClass"
      name="filter"
      :placeholder="placeholder"
      debounce="500"
      style="padding-left: 32px"
    ></b-form-input>
    <b-icon-search
      class="position-absolute"
      style="left: 10px; top: 50%; transform: translateY(-50%); color: var(--gray-500)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { useTextFilterStore } from '@app/stores/tables/TextFilterStore'
import { mapWritableState } from 'pinia'

export default defineComponent({
  props: {
    placeholder: {
      type: String,
      required: false,
      default: 'Filter by Name, Title, Company, etc',
    },
    size: {
      type: String as PropType<'sm' | 'md' | 'lg'>,
      required: false,
      default: 'md',
    },
  },
  computed: {
    ...mapWritableState(useTextFilterStore, ['filter']),
    fontSizeClass() {
      return {
        'fs-sm': this.size === 'sm',
        'fs-lg': this.size === 'lg',
      }
    },
  },
})
</script>
